import React, { useState, useEffect } from 'react'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { Full as Loading } from 'components/Loading'
import { setTheme, applyTheme } from 'themes/utils'
import { Button, Card } from '@arnsbogroup/react-voicearchive'

const PublicPayPalPaymentPage = ({ match }) => {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(true)
  const [approvalUrl, setApprovalUrl] = useState(null)
  const [status, setStatus] = useState(null)
  const [brand, setBrand] = useState(null)
  const [invoiceHref, setInvoiceHref] = useState(null)
  const [order, setOrder] = useState(null)
  const hashId = match.params.hashId

  useEffect(() => {
    if (!hashId) {
      return
    }

    if (hashId) {
      fetch(`/rest/v2/paypal/${hashId}`)
        .then((response) => response.json())
        .then(({ data, success, errors }) => {
            if (!success) {
                toastr.error(errors.join(', '))
                return
            }
            setApprovalUrl(data.approveUrl)
            setStatus(data.status)
            setInvoiceHref(data.invoiceHref)
            setOrder(data.order)
            if (data.brand) {
              if(data.brand.theme) {
                setTheme(data.brand.theme)
              } else {
                applyTheme('base')
              }
              setBrand(data.brand)
            }
            setLoading(false)
        })
        .catch((error) => toastr.error(error))
    }
  }, [hashId])

  useEffect(() => {
    if (!status) {
      return
    }

    if (status == "APPROVED") {
      fetch(`/rest/v2/paypal/${hashId}/capture`)
        .then((response) => response.json())
        .then(({ data, success, errors }) => {
            if (!success) {
                toastr.error(errors.join(', '))
                return
            }
        })
        .catch((error) => toastr.error(error))
    }
  }, [status])


  if (loading || !hashId) {
    return <Loading />
  }

  const hasBeenPaid = approvalUrl == null && status != "CREATED"

  return (
    <Card className="flex justify-center items-center min-h-screen bg-gray-100 p-6">
      <div className="bg-white p-8 text-center w-full max-w-md shadow-lg rounded-lg">
        <div className="mb-12">
          <img className="mx-auto w-2/5" src={brand.logo_dark} alt="Brand Logo" />
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-6">
          {!hasBeenPaid ? (
            <FormattedMessage
              {...messages.title}
              values={{
                orderId: order?.uid,
                orderName: order?.name
              }}
            />
          ) : (
            <FormattedMessage
              {...messages.titlePayed}
              values={{
                orderId: order?.uid,
                orderName: order?.name
              }}
            />
          )}
        </h1>
        <p className="text-gray-600 mb-4 whitespace-pre-wrap">
          {!hasBeenPaid ? (
            <>
              {
                formatMessage(messages.subtitle, {
                  a: (chunks) => (
                    <a className="text-blue-600 underline" href={invoiceHref} target="_blank">
                      {chunks}
                    </a>
                  )})
              }
            </>
          ) : (
            <>
              {
                formatMessage(messages.subtitlePayed, {
                  a: (chunks) => (
                    <a className="text-blue-600 underline" href={invoiceHref} target="_blank">
                      {chunks}
                    </a>
                  )})
              }
            </>
          )}
        </p>
        {!hasBeenPaid &&
          <>
            <Button
              onClick={() => window.location.href = approvalUrl}
            >
              <FormattedMessage {...messages.pay} />
            </Button>
            <div className="mt-4">
              <i>
                <FormattedMessage {...messages.instructions} />
              </i>
            </div>
          </>
        }
      </div>
    </Card>
  )
}

export default PublicPayPalPaymentPage
